import { jsx as _jsx } from "react/jsx-runtime";
import { InputSelect } from "../../../../InputSelect";
export const SingleOptionFilter = (props) => {
    const { label, helperLabel, options, value, onChange, } = props;
    return (_jsx(InputSelect, { label: label, ariaLabel: label, helperLabel: helperLabel, options: options, value: value, onChange: onChange }));
};
